import { State } from 'model/State';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { getFromHamsClient } from 'util/mac/api/partnerMigration/get';

export const getPartnerWhitelistStatus = async (orgId: number, state: State) =>
  fetchWithParamValidation(
    ({ id }) => getFromHamsClient(`/${id}/whitelist-status`, state, { id: orgId }),
    {
      id: orgId,
    },
  );
